import AnnotationIssues from "./AnnotationIssues";
import { Fragment, useEffect, useRef, useState } from "react";
import { BENCHMARK_CRITERIA, useBenchmarkTakeoverStore } from "src/stores/benchmarkTakeoverStore";

// Both scorecards are available without scroll or reading-time gates.

export default function RatingPanel({ sample, onNext, onBack }) {
  const scores = useBenchmarkTakeoverStore((state) => state.scores[sample]);
  const aiIsms = useBenchmarkTakeoverStore((state) => state.aiIsms[sample]);
  const setScore = useBenchmarkTakeoverStore((state) => state.setScore);
  const setAiIsms = useBenchmarkTakeoverStore((state) => state.setAiIsms);

  const [isScrolled, setIsScrolled] = useState(false);
  const ratingsRef = useRef(null);

  // Each scorecard starts at its first criterion when switching samples.
  useEffect(() => {
    setIsScrolled(false);
    if (ratingsRef.current) ratingsRef.current.scrollTop = 0;
  }, [sample]);

  const sampleRated = BENCHMARK_CRITERIA.every(({ key }) => scores[key] >= 1);

  return (
    <>
      <div
        ref={ratingsRef}
        className={`ratings${isScrolled ? " is-scrolled" : ""}`}
        onScroll={(event) => setIsScrolled(event.currentTarget.scrollTop > 8)}
      >
        <AnnotationIssues sample={sample} />
        <h2 className="ratings-heading">What did you think of Option {sample}?</h2>
        {BENCHMARK_CRITERIA.map(({ key, title, description }) => (
          <section
            className="criterion"
            key={key}
          >
            <h3>
              {title}{" "}
              <span
                className="required-mark"
                aria-hidden="true"
              >
                *
              </span>
            </h3>
            <p>{description}</p>
            <div className="score-row">
              <div
                className="scale"
                role="radiogroup"
                aria-label={`${title}, Option ${sample}`}
              >
                {[1, 2, 3, 4, 5].map((score) => {
                  const id = `bt-${key}-${sample}-${score}`;
                  return (
                    <Fragment key={score}>
                      <input
                        type="radio"
                        id={id}
                        name={`bt-${key}-${sample}`}
                        value={score}
                        checked={scores[key] === score}
                        onChange={() => setScore(sample, key, score)}
                      />
                      <label htmlFor={id}>{score}</label>
                    </Fragment>
                  );
                })}
              </div>
              <div
                className="scale-legend"
                aria-hidden="true"
              >
                <span>Weak</span>
                <span>Strong</span>
              </div>
            </div>
          </section>
        ))}
        <div className="ai-isms-field">
          <label htmlFor={`bt-ai-isms-${sample}`}>Which AI-isms did you notice?</label>
          <p
            className="ai-isms-help"
            id={`bt-ai-isms-help-${sample}`}
          >
            Any words, phrases, paragraph or chapter-level patterns? Anything that felt machine-made?
          </p>
          <textarea
            id={`bt-ai-isms-${sample}`}
            aria-describedby={`bt-ai-isms-help-${sample}`}
            placeholder="e.g. overexplained feelings, too many rhetorical contrasts, generic sensory beats"
            maxLength={10000}
            value={aiIsms}
            onChange={(event) => setAiIsms(sample, event.target.value)}
          ></textarea>
        </div>
      </div>
      <div
        className={`stage-actions${sample === "B" ? " has-back" : ""}`}
      >
        {sample === "B" && (
          <button
            className="back"
            type="button"
            onClick={onBack}
          >
            Back
          </button>
        )}
        <button
          className="continue"
          type="button"
          disabled={!sampleRated}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </>
  );
}
